import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonComponent } from '../button/button.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-confirmation-modal',
  imports: [ButtonComponent, TranslateModule],
  templateUrl: './confirmation-modal.component.html',
  styleUrl: './confirmation-modal.component.scss'
})
export class ConfirmationModalComponent {
  @Input() title: string = '';
  @Input() message: string = '';
  @Input() confirmLabel: string = 'BUTTONS.CONFIRM';
  @Input() cancelLabel: string = 'BUTTONS.CANCEL';
  @Input() showCancel: boolean = true;
  @Input() loading: boolean = false;

  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  // Emit confirm action
  onConfirm() {
    this.confirm.emit();
  }

  // Emit cancel action
  onCancel() {
    if (this.loading) {
      return;
    }
    this.cancel.emit();
  }
}
